'use client';

import NextError from 'next/error';
import { useEffect } from 'react';
import { logFromErrorBoundary } from '@/app/common/components/ErrorBoundary/utils.ts';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    logFromErrorBoundary(error, 'GlobalError', false);
  }, [error]);

  return (
    // eslint-disable-next-line jsx-a11y/html-has-lang
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
